import React from 'react';
import IconAdd from '../images/IconAdd.jsx';
import BaseCard from './BaseCard.jsx';
import BaseInput from '../form/BaseInput.jsx';
import IconClear from '../images/IconClear.jsx';

const Notes = ({ fields, append, control, clearErrors, remove }) => {
    const addNewNote = () => {
        append({
            note: ''
        });
    };

    return (
        <BaseCard className='border-0 bg-theme1-pinkGray p-0 pb-6 max-w-3xl w-full mx-auto'>
            <div className='max-w-3xl w-full mx-auto px-8 flex items-center justify-between p-6'>
                <div className='text-2xl font-bold text-theme1-title2'>Notes</div>
                <span className='cursor-pointer' onClick={() => addNewNote()}>
                    <IconAdd className='fill-theme1-text1' />
                </span>
            </div>
            <BaseCard className='border-0 m-0 mb-6 p-4 mx-8 shadow-none w-auto'>
                <div className='max-w-3xl w-full mx-auto px-4'>
                    {fields.length > 0 && (
                        <>
                            {fields.map((note, index) => {
                                return (
                                    <div key={note.id} className='w-full flex items-center mb-4'>
                                        <div className='flex-grow'>
                                            <BaseInput
                                                inputClassName='p-1 border-t-0 border-l-0 border-r-0 rounded-none border-b border-theme1-cardStroke'
                                                type='text'
                                                control={control}
                                                placeholder='Note ...'
                                                name={`notes[${index}].note`}
                                                clearErrors={clearErrors}
                                                errors={[]}
                                            />
                                        </div>
                                        <div className='ml-2 cursor-pointer' onClick={() => remove(index)}>
                                            <IconClear className='mt-2 fill-theme1-border1 w-4 h-4' />
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
            </BaseCard>
        </BaseCard>
    );
};

export default Notes;
